import React from 'react';
import {connect} from 'react-redux';
import {Button} from 'antd';
import {LogoutOutlined} from '@ant-design/icons';

import {trb, i18, Logout} from '../../Utilities';

const mobile = window.innerWidth < 427;

const LogoutButton = (props) => {
    const {logged} = props;

    return logged ? (
        <Button
            type="link"
            onClick={() => Logout()}
            icon={<LogoutOutlined />}
        >
            {mobile ? null : trb(i18.Buttons.Logout)}
        </Button>
    ) : null;
};

function mapStateToProps(state) {
    const {logged} = state.AuthReducers;

    return {
        logged
    };
}

const connectedLogoutButton = connect(mapStateToProps)(LogoutButton);
export {connectedLogoutButton as LogoutButton};
